<template>
  <aside class="pp-sidebar" aria-label="Profile highlights">
    <div
      v-if="jobRoles.length"
      class="pp-sidebar__card"
      :class="{ 'pp-sidebar__card--desktop-only': hideRolesOnMobile }"
    >
      <h3 class="pp-sidebar__title">Open to roles</h3>
      <ul class="pp-sidebar__list">
        <li v-for="role in jobRoles" :key="role">{{ role }}</li>
      </ul>
    </div>

    <div v-if="skills.length" class="pp-sidebar__card">
      <h3 class="pp-sidebar__title">Skills</h3>
      <div class="pp-pills">
        <span v-for="skill in skills" :key="skill" class="pp-pill">{{ skill }}</span>
      </div>
    </div>

    <div
      v-if="highestEducation"
      class="pp-sidebar__card"
      :class="{ 'pp-sidebar__card--desktop-only': hideEducationOnMobile }"
    >
      <h3 class="pp-sidebar__title">Education</h3>
      <p class="pp-sidebar__highlight">{{ highestEducation.title }}</p>
      <p v-if="highestEducation.university" class="pp-sidebar__meta">{{ highestEducation.university }}</p>
      <p v-if="highestEducation.year" class="pp-sidebar__meta">Class of {{ highestEducation.year }}</p>
    </div>

    <div v-if="languages.length" class="pp-sidebar__card">
      <h3 class="pp-sidebar__title">Languages</h3>
      <div class="pp-pills">
        <span v-for="lang in languages" :key="lang" class="pp-pill pp-pill--muted">{{ lang }}</span>
      </div>
    </div>

    <div v-if="communicationLabel" class="pp-sidebar__card">
      <h3 class="pp-sidebar__title">Communication</h3>
      <p class="pp-sidebar__meta">{{ communicationLabel }}</p>
    </div>

    <div class="pp-sidebar__card pp-sidebar__card--cta">
      <p class="pp-sidebar__cta-text">Discover more candidates and jobs on Hireclap.</p>
      <a href="/jobs" class="pp-btn pp-btn--outline pp-sidebar__cta-btn">Explore Hireclap</a>
    </div>
  </aside>
</template>

<script>
export default {
  name: 'PublicProfileSidebar',
  props: {
    jobRoles: { type: Array, default: () => [] },
    skills: { type: Array, default: () => [] },
    highestEducation: { type: Object, default: null },
    languages: { type: Array, default: () => [] },
    communicationLabel: { type: String, default: '' },
    hideRolesOnMobile: { type: Boolean, default: false },
    hideEducationOnMobile: { type: Boolean, default: false },
  },
};
</script>
